import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        filePath: '<'
    },
    template: `
        <iframe src="{{ vm.src }}" class="pdf-iframe"
                style="width:100%;height:100vh;border:0;overflow:none"
                allow="fullscreen" allowfullscreen/>
        <style>
            html { overflow: hidden; }
        </style>
    `
})
export default class {
    constructor ($sce) {
        this.$sce = $sce;
    }

    $onInit () {
        const pdfViewerPath = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.filePath)}`;
        this.src = this.$sce.trustAsResourceUrl(pdfViewerPath);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/authoringTool/iframe/microsoftViewer/index.js